import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import AiInvoiceBanner from "./../../assets/images/banner/at.png";

const Wa_AT = () => {
  pageTitle("Whatsapp Attendance Tracking");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div
        className="ai-overlay-wrapper"
        style={{ backgroundImage: `url(${AiInvoiceBanner})` }}
      >
        {/* <img src={AiInvoiceBanner} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          {/* Centered text */}
          <div className="ai-overlay-center-project-text">
            <h2 className="ai-overlay-project">
              AI-Powered <br></br>Whatsapp Attendance Tracking
            </h2>
          </div>
        </div>
      </div>

      <section className="siw-rpa-section" style={{ marginBottom: "30px" }}>
        <div className="siw-rpa-container container mb-5">
          <div className="row align-items-stretch">
            <h3 className="siw-project-heading">
              Say goodbye to manual attendance and unlock real-time tracking
              by AI-Powered WhatsApp.
            </h3>
            {/* LEFT SIDE - VIDEO */}
            <div className="col-md-6 mt-2 d-flex flex-column">
              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/MrTOnAjBVsY?si=eeGCGI9xZkY4xx62"
                  title="Introducing Text To Speech"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* RIGHT SIDE - CTA */}
            <div className="col-md-6 mt-2 d-flex">
              <div className="siw-rpa-cta w-100 d-flex flex-column justify-content-center text-center">
                <h4 style={{ color: "rgb(230, 233, 55)" }}>
                  Free Trial Available
                </h4>

                <p>
                  <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                    SiW
                  </span>{" "}
                  is currently offering a free trial session for businesses
                  looking to modernize attendance tracking through WhatsApp and
                  AI.
                </p>

                <p>
                  Our team will create a dedicated AI-powered app tailored to
                  your workflow, helping you capture attendance records
                  instantly, reduce manual effort, and improve operational
                  visibility.
                </p>

                <a href="/contact" className="siw-rpa-btn mt-3">
                  <i className="bi bi-calendar-week btn-icon"></i>
                  Start a Free Trial
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterOne></FooterOne>
    </>
  );
};
export default Wa_AT;
